"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ImagePicker_1 = __importDefault(require("../../../../common/ImagePicker/ImagePicker"));
var TextArea_1 = __importDefault(require("../../../../common/TextInput/TextArea"));
var TextInput_1 = __importDefault(require("../../../../common/TextInput/TextInput"));
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../lib/general");
var CategorySelector_1 = __importDefault(require("../../Knowledge/Selectors/CategorySelector"));
var SortingSelector_1 = __importDefault(require("../../Knowledge/Selectors/SortingSelector"));
var validateForm_1 = require("../Validate/validateForm");
var VideoForm = function (_a) {
    var categoryList = _a.categoryList, languages = _a.languages, saveClickStatus = _a.saveClickStatus, updateSaveClickStatus = _a.updateSaveClickStatus, categoryId = _a.categoryId, sortingList = _a.sortingList, saveGuideData = _a.saveGuideData, editGuideParam = _a.editGuideParam;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var videoRef = (0, react_1.createRef)();
    var arr = languages;
    var arr1 = languages;
    var arr2 = languages;
    var getCurrentLang = i18n.language;
    var _c = (0, react_1.useState)({
        id: null,
        title: JSON.stringify(arr),
        category: null,
        description: JSON.stringify(arr),
        thumbnail: arr1,
        video: arr2,
        sorting: null,
        organization_id: organization.id,
    }), formData = _c[0], setFormData = _c[1], _d = (0, react_1.useState)({
        thumbnail: null,
        video: null,
    }), fileName = _d[0], setFileName = _d[1], _e = (0, react_1.useState)(null), error = _e[0], setError = _e[1];
    (0, react_1.useEffect)(function () {
        if (saveClickStatus) {
            updateSaveClickStatus();
            saveGuide();
        }
    }, [saveClickStatus]);
    var resetDocumentRef = function () {
        videoRef.current.value = null;
    };
    (0, react_1.useEffect)(function () {
        resetDocumentRef();
        setFileName(function (prevState) { return (__assign(__assign({}, prevState), { thumbnail: null, video: null })); });
    }, [getCurrentLang]);
    (0, react_1.useEffect)(function () {
        if (editGuideParam) {
            resetDocumentRef();
            setFileName({
                thumbnail: null,
                video: null,
            });
            setFormData(editGuideParam);
        }
    }, [editGuideParam]);
    (0, react_1.useEffect)(function () {
        if (formData && formData.category !== null) {
            var check_category = typeof formData.category === "object" && formData.category !== null
                ? formData.category.value
                : formData.category;
            categoryId(check_category);
        }
    }, [formData]);
    var saveGuide = function () {
        var res = (0, validateForm_1.ValidateGuideForm)(formData, getCurrentLang);
        if (res.status === "error") {
            setError(res);
        }
        else {
            window.scrollTo(0, 0);
            saveGuideData(formData);
        }
    }, onHandleChange = function (value, data_type, isJson) {
        setError(null);
        if (isJson === "json") {
            var dataObj_1 = JSON.parse(formData[data_type]);
            dataObj_1[getCurrentLang] = value;
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else if (isJson === "obj") {
            var currentInput_1 = data_type;
            var video_file_1 = value.video_file, thumbnail_file_1 = value.thumbnail_file;
            if (video_file_1) {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = video_file_1.name, _a)));
                });
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[currentInput_1] = __assign(__assign({}, prevState[currentInput_1]), (_b = {}, _b[getCurrentLang] = video_file_1, _b)), _a)));
                });
            }
            if (thumbnail_file_1) {
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["thumbnail"] = __assign(__assign({}, prevState["thumbnail"]), (_b = {}, _b[getCurrentLang] = thumbnail_file_1, _b)), _a)));
                });
            }
        }
        else {
            if (data_type === "icon") {
                setFileName(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = value.name, _a)));
                });
            }
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[data_type] = value, _a)));
            });
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: "form-container" },
            react_1.default.createElement(CategorySelector_1.default, { error: error && error.field === "category" && error.message, label: t("category"), list: categoryList, updateCategory: function (val) { return onHandleChange(val, "category", ""); }, value: formData.category }),
            react_1.default.createElement(TextInput_1.default, { error: error && error.field === "title" && error.message, label: t("title"), onChange: function (e) { return onHandleChange(e.target.value, "title", "json"); }, value: (0, general_1.isJsonWithAvailableLang)(formData.title, getCurrentLang.toLowerCase(), t) }),
            react_1.default.createElement(TextArea_1.default, { label: t("description"), onChange: function (e) {
                    return onHandleChange(e.target.value, "description", "json");
                }, value: (0, general_1.isJsonWithAvailableLang)(formData.description, getCurrentLang.toLowerCase(), t) }),
            react_1.default.createElement(SortingSelector_1.default, { list: sortingList, onChange: function (e) {
                    onHandleChange(e.sorting_id, "sorting", "");
                }, value: formData.sorting }),
            react_1.default.createElement(ImagePicker_1.default, { fileName: fileName, id: "video", imagechange: function (video_file, thumbnail_file) {
                    var file = { video_file: video_file, thumbnail_file: thumbnail_file };
                    onHandleChange(file, "video", "obj");
                }, imgref: videoRef, label: t("video"), mediatype: "video" }))));
};
exports.default = VideoForm;
